import React from 'react';
import { PlayerProfilePreview } from '../../index';// eslint-disable-line
import './EditHighlightHeader.scss';
import createDurationFromSeconds from "../../utils/createDurationFromSeconds";


const EditHighlightHeader = ({ sender, seekTime, duration })=> {
  const { avatar, fullName, firstName, lastName } = sender;
  const formatedSeekTime = seekTime ? createDurationFromSeconds(seekTime) : null;
  const formatedDuration = Math.round(duration);
  const title = formatedSeekTime ?
    `${formatedDuration} Sec (${formatedSeekTime})` :
    `${formatedDuration} Sec`
  return (
    <div className="edit-highlight-header">
      <PlayerProfilePreview
        isTeam={false}
        avatar={avatar}
        fullName={fullName}
        firstName={firstName}
        lastName={lastName}
      />
      <div className="edit-highlight-header__details">
        <span className="edit-highlight-header__details__time">{title}</span>
      </div>
    </div>
  );
};

export default EditHighlightHeader;
